/* tslint:disable */

declare var Object: any;
export interface SFClaimCancelRequestInterface {
  "id"?: number;
}

export class SFClaimCancelRequest implements SFClaimCancelRequestInterface {
  "id": number;
  constructor(data?: SFClaimCancelRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFClaimCancelRequest`.
   */
  public static getModelName() {
    return "SFClaimCancelRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFClaimCancelRequest for dynamic purposes.
  **/
  public static factory(data: SFClaimCancelRequestInterface): SFClaimCancelRequest {
    return new SFClaimCancelRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFClaimCancelRequest',
      plural: 'SFClaimCancelRequests',
      path: 'SFClaimCancelRequests',
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFClaimCancelRequest.ts